import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { api, setInitData } from './api.js';
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [auth, setAuth] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const w = window;
        const id = w.Telegram?.WebApp?.initData
            ?? new URLSearchParams(window.location.search).get('initData')
            ?? '';
        setInitData(id);
        if (!id) {
            setError('no_init_data');
            return;
        }
        api('/api/me')
            .then((r) => setAuth({ ...r, displayName: r.user.display_name }))
            .catch((e) => setError(e instanceof Error ? e.message : String(e)));
    }, []);
    if (error)
        return _jsxs("p", { className: "p-4 text-red-600", children: ["\u062E\u0637\u0627: ", error] });
    if (!auth)
        return _jsx("p", { className: "p-4", children: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026" });
    return _jsx(Ctx.Provider, { value: auth, children: children });
}
export function useAuth() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error('No auth');
    return v;
}
